import { render } from "./InventorySlot.vue?vue&type=template&id=6b7c5a50&scoped=true"
import script from "./InventorySlot.vue?vue&type=script&lang=js"
export * from "./InventorySlot.vue?vue&type=script&lang=js"

import "./InventorySlot.vue?vue&type=style&index=0&id=6b7c5a50&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7c5a50"]])

export default __exports__